/** Publish each account read as it arrives; optional account chrome is independent. */
export async function loadAccountBootstrap<Usage, History extends { usage?: Usage }>(options: {
  usage: () => Promise<Usage>;
  history: () => Promise<History>;
  isCurrent: () => boolean;
  onUsage: (usage: Usage) => void;
  onHistory: (history: History, usage?: Usage) => void;
  onComplete: (results: [PromiseSettledResult<Usage>, PromiseSettledResult<History>]) => void;
}): Promise<void> {
  let usage: Usage | undefined;
  let historyUsage: Usage | undefined;
  const usageRead = Promise.resolve().then(options.usage).then((value) => {
    usage = value;
    if (options.isCurrent() && historyUsage === undefined) options.onUsage(value);
    return value;
  });
  const historyRead = Promise.resolve().then(options.history).then((value) => {
    historyUsage = value.usage;
    if (options.isCurrent()) {
      if (value.usage !== undefined) options.onUsage(value.usage);
      options.onHistory(value, value.usage ?? usage);
    }
    return value;
  });
  const results = await Promise.allSettled([usageRead, historyRead]);
  if (options.isCurrent()) options.onComplete(results);
}
